<template>
  <div v-if="show" class="modal" :class="[theme === 'light' ? 'light' : 'dark']">
    <div class="modal-outermost-container" @click.self.stop="handleClick">
      <div
        :style="{ width: width, height: height, maxWidth: maxWidth }"
        class="modal-innermost-container"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    width: {
      type: [String, Number],
      default: 'auto',
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    maxWidth: {
      type: [String, Number],
      default: 'initial',
    },
    minHeight: {
      type: [String, Number],
      default: 'initial',
    },
    show: {
      type: Boolean,
      required: true,
    },
    theme: {
      type: String,
      default: 'light',
    },
    stopEvent: Boolean,
  },
  methods: {
    handleEscape(event) {
      if (this.stopEvent) return;

      if (event.key === 'Esc' || event.key === 'Escape') {
        this.show && this.$emit('close');
      }
    },
    handleClick() {
      if (this.stopEvent) return;

      this.show && this.$emit('close');
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscape);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleEscape);
  },
};
</script>
